export default {"src":"/_next/static/media/aurora.5a46037d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};